import {Router, Route, NavigationStart} from '@angular/router';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ModuleService} from './module.service';
import {MessageService} from 'primeng/api';
import {AppService} from 'app/app.service';
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
    providedIn: 'root'
})
export class RouterService {

    existingRoutes: BehaviorSubject<Route[]>;

    constructor(public router: Router, private appService: AppService,
        private moduleService: ModuleService, private messageService: MessageService,
        private spinner: NgxSpinnerService) {
        this.existingRoutes = new BehaviorSubject<Route[]>(this.routes);
    }

     init() {
        this.router.events.subscribe(async event => {
            if (event instanceof NavigationStart) {
                await this.refererRoute(event);
            }
        });
    }
    private async refererRoute(event:any) {
        if (!this.routeIsRegistered(event.url.substring(1)) && event.url.startsWith("/process")) {
            let alias = event.url.split("/")[2];
            let formAlias = event.url.split("/")[4];
            this.spinner.show();
            if (alias) {
                this.appService.getProcess(alias, formAlias).then(process => {
                    process.location = 'app/bundles'+ process.path + '.umd.js';
                    this.registerRouteProcess(process,event);
                },
                    error => {
                        this.messageService.add({
                            severity: 'error', summary: 'Error while load process', detail: error
                        });
                        this.spinner.hide();
                    })
            }
        }
    }
    public registerRoutes(processMap: Map<any, any>) {
        // load up the umd file and register the route whenever succeeded.
        for (let process of processMap.values()) {
            this.registerRouteProcess(process);
        }
        this.spinner.hide();
    }
    private registerRouteProcess(process: any,event :any = false) {
        // load up the umd file and register the route whenever succeeded.
        this.spinner.show();
        this.moduleService.loadModuleSystemJS(process).then( (exports) => {
            this.createAndRegisterRoute(process, exports);
            if(event && this.routeIsRegistered(this.getPath(process))){
               this.router.navigate([event.url]);
            }
            this.spinner.hide();
        }, (err) => {
            this.messageService.add({
                severity: 'error', summary:
                    `${process.alias} could not be found, did you copy the umd file to ${process.location}?`, detail: err
            });
            this.spinner.hide();
        });
    }

    private get routes(): Route[] {
        var routesToReturn = this.router.config;
        return routesToReturn.filter(x => x.path !== "");
    }

     createAndRegisterRoute(process: any, exports: any) {
        let route: Route = {
            path: this.getPath(process),
            loadChildren: () => exports[`${process.processTraitement}`]
        };
        this.registerRoute(route);
    }

    routeIsRegistered(path: string) {
        return this.router.config.filter(r => r.path === '')[0]
        .children.filter(r => path.startsWith(r.path) && r.path.startsWith('process')).length > 0;
    }

    registerRoute(route: Route) {
        if (this.routeIsRegistered(route.path)) return;
        this.router.config.filter(r => r.path === '')[0].children.push(route);
        this.updateRouteConfig(this.router.config);
    }

    unRegisterRoute(path: string) {
        this.updateRouteConfig(this.router.config.filter(route => route.path !== path));
    }

    private updateRouteConfig(config) {
        this.router.resetConfig(config);
        this.existingRoutes.next(this.routes);
    }


    private getPath(process: any): string {
        return 'process/' + process.alias + '/form';
    }

}